export default __webpack_public_path__ + "static/media/MH-logo.b60751f7.png";